'use client';

import { useTranslations } from 'next-intl';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import { UiKitDialogBase } from '@/fo/ui/kit/dialog/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';

import { styles } from './UiKitModalBase.styles';

export interface UiKitModalBaseProps {
  children?: React.ReactNode;
  title: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  className?: string;
  showMobileBack?: boolean;
}

export function UiKitModalBase({
  children,
  title,
  isOpen,
  setIsOpen,
  className,
  showMobileBack = false
}: UiKitModalBaseProps) {
  const t = useTranslations();
  const slots = styles();
  const isMobile = useMediaQuery('md', 'max');

  const back = (
    <div className={slots.closeButton()}>
      <ChevronIcon className={slots.closeButtonIcon()} />
      {t('back')}
    </div>
  );

  return (
    <UiKitDialogBase
      title={title}
      open={isOpen}
      fullScreen={isMobile}
      vertical="full"
      horizontal="right"
      customCloseButton={showMobileBack && isMobile ? back : undefined}
      onOpenChange={setIsOpen}
      className={slots.dialog({
        className: `${className ?? ''} ${showMobileBack ? '' : 'max-md:pt-16'}`
      })}
      contentClassName="p-0"
      buttonIconClassName="size-7 sm:size-10"
      autoFocus={false}
    >
      {title && <p className={slots.title()}>{title}</p>}
      {children}
    </UiKitDialogBase>
  );
}
